/**
 * Navigation seam.
 *
 * Assigning `window.location.href` directly from inside a service makes that
 * code path untestable: as of the jsdom that ships with Jest 30, `Location` is
 * a live browser object that cannot be replaced, redefined, or deleted —
 * `Object.defineProperty(window, 'location', …)` throws
 * "Cannot redefine property: location", and `delete window.location` is
 * silently ignored. Any test that needs to assert "this redirects to /login"
 * therefore has nothing to hook.
 *
 * Routing the assignment through these functions gives tests a normal module
 * export to spy on (`jest.spyOn(navigation, 'redirectToLogin')`) without
 * touching the global. See issue #583.
 */

/** Navigate the browser to `path`. No-op outside a browser (SSR, tests). */
export function navigateTo(path: string): void {
  if (typeof window === "undefined" || !window.location) return;
  window.location.href = path;
}

/** Send the user to the login screen after their session ends. */
export function redirectToLogin(): void {
  navigateTo("/login");
}
